import { render, staticRenderFns } from "./FormFieldsGroup.vue?vue&type=template&id=609bf01c"
import script from "./FormFieldsGroup.vue?vue&type=script&lang=js"
export * from "./FormFieldsGroup.vue?vue&type=script&lang=js"
import style0 from "./FormFieldsGroup.vue?vue&type=style&index=0&id=609bf01c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports